import React from "react";
import { Table } from "react-bootstrap";

export default function SettingsList({ settings, t }) {
  return (
    <>
      <h4>{t("settingsListTitle")}</h4>
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>{t("id")}</th>
            <th>{t("name")}</th>
            <th>{t("settingsValue")}</th>
          </tr>
        </thead>
        <tbody>
          {settings.length === 0 ? (
            <tr>
              <td colSpan="3">{t("settingsEmpty")}</td>
            </tr>
          ) : (
            settings.map((setting) => (
              <tr key={setting.settingId}>
                <td>{setting.settingId}</td>
                <td>{t(setting.name)}</td>
                <td>{t(setting.value)}</td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
    </>
  );
}
